export const AI_EXHIBIT_COLORS = Object.freeze({
  background: "#07111f",
  surface: "#0d1b2a",
  surfaceRaised: "#13263a",
  border: "#29445f",
  text: "#f8fafc",
  muted: "#a8bacb",
  accent: "#4fd1ff",
  accentSoft: "#0f3345",
  success: "#6ee7b7",
  warning: "#facc15",
});

export const AI_EXHIBIT_MAX_WIDTH = 1280;
